import {Autocomplete, Chip, TextField, useTheme} from "@mui/material";
import {observer} from "mobx-react";
import FormFieldBase from "./FormFieldBase";

function FormAutocompleteMultipleSelectField({
                                                 label, field, options, readOnly = false,
                                                 updateValue = async (event, newValue) => {
                                                     if (form) {
                                                         await form.updateFieldWithValue(fieldName, newValue)
                                                     } else {
                                                         field.updateValue(newValue)
                                                     }
                                                 },
                                                 clear = undefined, onChipDelete = undefined,
                                                 isOptionEqualToValue = (option, value) => option.value === value.value,
                                                 form = undefined,
                                                 fieldName = undefined,
                                             }) {
    const theme = useTheme();
    const formField = form ? form.getFieldByName(fieldName) : field;
    const readonly = form ? form.isReadonly(fieldName) : readOnly;

    function sortedOptions() {
        let sortedOptions = options.slice().sort((option, anotherOption) =>
            option.label.charAt(0).localeCompare(anotherOption.label.charAt(0))
        );
        return sortedOptions.map((option) => ({
            label: option.label,
            value: option.value,
        }));
    }

    return (
        <FormFieldBase>
            <Autocomplete
                multiple
                disablePortal
                disableClearable
                id={label}
                style={{
                    backgroundColor: theme.brand.field,
                    borderRadius: '5px',
                }}
                fullWidth
                isOptionEqualToValue={isOptionEqualToValue}
                getOptionLabel={(option) => option.label || ""}
                disabled={readonly}
                onChange={(event, newValues, reason) => {
                    if (reason === 'selectOption' || reason === 'removeOption') {
                        let allValues = newValues.map((nv) => nv.value);
                        allValues = [...new Set(allValues)];
                        updateValue(event, allValues);
                    }
                    if (reason === 'clear') {
                        if (clear) {
                            clear();
                        } else {
                            updateValue(event, []);
                        }
                    }
                }}
                value={sortedOptions().filter((option) => formField.hasThisValue(option.value))}
                renderTags={(selected, getTagProps) =>
                    selected.map((option, index) => (
                        <Chip
                            {...getTagProps({index})}
                            key={option.value}
                            label={option.label}
                            sx={{
                                margin: "2px",
                                backgroundColor: theme.palette.warning.main,
                                color: theme.palette.primary.contrastText,
                            }}
                            onDelete={!readOnly ? () => {
                                const tagProps = getTagProps({index});
                                if (tagProps.onDelete) {
                                    tagProps.onDelete();
                                }
                                if (onChipDelete) {
                                    onChipDelete(option.value);
                                }
                            } : undefined}
                        />
                    ))
                }
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={label}
                        InputProps={{
                            ...params.InputProps,
                        }}
                        sx={{
                            '& .MuiInputLabel-root, & .MuiInputLabel-shrink, & .MuiOutlinedInput-root, & .MuiInputBase-input': {
                                fontSize: theme.typography,
                            },
                        }}
                        required={!formField.isOptional}
                        error={formField.hasValue && !formField.isValid}
                    />
                )}
                options={sortedOptions()}
            />
        </FormFieldBase>
    );
}

export default observer(FormAutocompleteMultipleSelectField);